import { useState, useEffect } from 'react';
import Help from './Help.js';
import Unlimited from './Unlimited.js';
import BottomNav from './BottomNav.js';
import StreakCard from './StreakCard.js';
import PlayTab from './PlayTab.js';
import HistoryTab from './HistoryTab.js';
import StatsTab from './StatsTab.js';
import Game from './Game.js';
import { useUnlimited } from './Entitlements.js';

// History needs no standing link - tapping a locked board already asks. Play
// asks on the completion screen, so nothing sits in the way mid-board.
// `from` tells the sheet which perk the tap was really about.
const UNLIMITED_CTAS = {
  stats: { label: 'Play unsolved games with Unlimited', from: 'history' },
};

function App() {
  const [showHelp, setShowHelp] = useState(false);
  const [showUnlimited, setShowUnlimited] = useState(false);
  const [unlimitedContext, setUnlimitedContext] = useState(null);
  const [activeTab, setActiveTab] = useState('play');
  // The lesson runs with the chrome cleared away - it reaches up from Board
  const [teaching, setTeaching] = useState(false);
  const [replayGame, setReplayGame] = useState(null);
  const unlimited = useUnlimited();

  // Context lets the sheet answer the exact thing that was just blocked
  const openUnlimited = (context = null) => {
    setUnlimitedContext(context);
    setShowUnlimited(true);
  };

  // Decoding gives a fresh Game each time, so replaying the same board twice still takes
  const handleReplay = (gameCode) => {
    setReplayGame(Game.decode(gameCode));
    setActiveTab('play');
  };

  // Replay is the thing being sold, so tapping a board asks for the purchase
  const handleHistoryTap = unlimited ? handleReplay : () => openUnlimited({ from: 'history' });

  // Native flips this the moment a purchase or restore lands - drop the sheet
  useEffect(() => {
    if (unlimited) setShowUnlimited(false);
  }, [unlimited]);

  return (
    <div className="app">
      {/* On every tab: it is a standing fact about the player rather than
          something this board owns, and History and Statistics are exactly
          where someone goes to look at their own numbers.
          Not during the lesson, though - the tutorial board is not a real game
          and cannot move the count, so a streak there is a number that does
          not respond to anything they do. */}
      {!teaching && <StreakCard />}
      {showHelp && <Help setShowHelp={setShowHelp} />}
      {showUnlimited && <Unlimited onClose={() => setShowUnlimited(false)} context={unlimitedContext} />}

      <div style={{ display: activeTab === 'play' ? 'contents' : 'none' }}>
        <PlayTab
          active={activeTab === 'play'}
          replayGame={replayGame}
          unlimited={unlimited}
          onShowUnlimited={openUnlimited}
          onTutorialChange={setTeaching}
          onShowHelp={() => setShowHelp(true)}
        />
      </div>
      <div style={{ display: activeTab === 'history' ? 'contents' : 'none' }}>
        <HistoryTab onReplay={handleHistoryTap} />
      </div>
      <div style={{ display: activeTab === 'stats' ? 'contents' : 'none' }}>
        <StatsTab />
      </div>

      {!unlimited && UNLIMITED_CTAS[activeTab] && (
        <button
          className="unlimited-cta"
          onClick={() => openUnlimited({ from: UNLIMITED_CTAS[activeTab].from })}
        >
          <span className="unlimited-cta-mark">✦</span>
          {UNLIMITED_CTAS[activeTab].label}
          <span className="unlimited-cta-mark">✦</span>
        </button>
      )}

      {/* Nowhere to go until the lesson is done - four moves, and the tabs are
          waiting where they were */}
      {!teaching && <BottomNav activeTab={activeTab} onTabChange={setActiveTab} />}
    </div>
  );
}

export default App;
